import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from '../shared/service/auth.service';
import { UsuarioService } from '../shared/service/usuario.service';
import { Usuario } from '../shared/model/usuario/usuario.model';
import { HomeBuscasService } from '../shared/service/home-buscas.service';
import { LembreteService } from '../shared/service/lembrete.service';
import { QtdAtendimentos } from '../shared/model/homeBuscas/qtd-atendimentos.model';
import { MenuMobileComponent } from '../shared/components/redesign/menu-mobile/menu-mobile.component';

interface CartaoMetrica {
  valor: string;
  label: string;
  labelCurto: string;
  mask: string;
  cor: string;
  corFundo: string;
}

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css'
})
export class HomeComponent implements OnInit {
  usuarioLogado?: Usuario;

  qtd: QtdAtendimentos = new QtdAtendimentos();
  lembretesHoje = 0;

  carregandoMetricas = true;
  carregandoLembretes = true;

  private readonly authService = inject(AuthService);
  private readonly usuarioService = inject(UsuarioService);
  private readonly homeBuscasService = inject(HomeBuscasService);
  private readonly lembreteService = inject(LembreteService);
  private readonly dialog = inject(MatDialog);
  private readonly router = inject(Router);

  ngOnInit() {
    this.usuarioLogado = this.authService.getUsuarioLogado();
    this.buscarMetricas();
    this.buscarLembretesHoje();
    this.buscarInformacoesComplementaresUsuarioLogado();
  }

  buscarInformacoesComplementaresUsuarioLogado() {
    this.usuarioService.buscarUsuarioLogado().subscribe({
      next: res => this.usuarioLogado = res
    });
  }

  buscarMetricas() {
    this.carregandoMetricas = true;
    this.homeBuscasService.buscarResumoHome().subscribe({
      next: res => this.qtd = res,
      error: () => this.carregandoMetricas = false,
      complete: () => this.carregandoMetricas = false
    });
  }

  buscarLembretesHoje() {
    this.carregandoLembretes = true;
    this.lembreteService.contarHoje().subscribe({
      next: res => this.lembretesHoje = res,
      error: () => this.carregandoLembretes = false,
      complete: () => this.carregandoLembretes = false
    });
  }

  get primeiroNome(): string {
    const nome = this.usuarioLogado?.nome?.trim();
    return nome ? nome.split(' ')[0] : 'Bem-vindo';
  }

  get metricas(): CartaoMetrica[] {
    return [
      {
        valor: (this.qtd.qtdAtendimentoMensal ?? 0) + '',
        label: 'Total de Atendimentos (mês)',
        labelCurto: 'Atendimentos (mês)',
        mask: 'home-mask-chat',
        cor: 'var(--primary)',
        corFundo: '#F3E9FE'
      },
      {
        valor: this.formatarHora(this.qtd.tempoMedioAtendimentoDiario),
        label: 'T. Médio de Atendimento (Dia)',
        labelCurto: 'T. Médio Atend. (Dia)',
        mask: 'home-mask-relogio',
        cor: '#3B5BDB',
        corFundo: '#EEF1FE'
      },
      {
        valor: this.formatarHora(this.qtd.tempoMedioAtendimentoMensal),
        label: 'T. Médio de Atendimento (Mês)',
        labelCurto: 'T. Médio Atend. (Mês)',
        mask: 'home-mask-relogio',
        cor: '#3B5BDB',
        corFundo: '#EEF1FE'
      },
      {
        valor: this.formatarHora(this.qtd.tempoMedioRespostaDiario),
        label: 'T. Médio de Resposta (Dia)',
        labelCurto: 'T. Médio Resp. (Dia)',
        mask: 'home-mask-resposta',
        cor: '#0EA5A5',
        corFundo: '#E1F6F6'
      },
      {
        valor: this.formatarHora(this.qtd.tempoMedioRespostaMensal),
        label: 'T. Médio de Resposta (Mês)',
        labelCurto: 'T. Médio Resp. (Mês)',
        mask: 'home-mask-resposta',
        cor: '#3F9A3E',
        corFundo: '#EAF7EA'
      }
    ];
  }

  formatarHora(valor?: number): string {
    const v = valor ?? 0;
    return `${v < 10 ? '0' + v : v}h`;
  }

  irParaChat() {
    this.router.navigate(['/chat']);
  }

  irParaLembretes() {
    this.router.navigate(['/lembretes']);
  }

  abrirMenuMobile() {
    this.dialog.open(MenuMobileComponent, {
      width: '85%',
      maxWidth: '320px',
      height: '100dvh',
      maxHeight: '100dvh',
      position: { top: '0', left: '0' },
      panelClass: 'slide-modal-esquerda'
    });
  }
}
